import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'viva-error-popup',
    templateUrl: './viva-error-popup.component.html',
    styleUrls: ['./viva-error-popup.component.scss'],
    standalone: false
})
export class VivaErrorPopupComponent implements OnInit {

  readonly dialogTitleId = 'viva-error-popup-title';

  @Input() message?: string;

  constructor(private modalController: ModalController) { }

  ngOnInit() {}

  @HostListener('document:keydown.escape')
  onEscape(): void {
    void this.dismiss();
  }

   async dismiss() {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }

}
